import marketingApi from '@/services/api/marketingApi';
import {
  baseActions, baseGetters, baseMutations, baseState,
} from '@/store/components/base';
import {
  sortActions, sortGetters, sortMutations, sortState,
} from '@/store/components/sort';
import {
  paginationActions, paginationGetters, paginationMutations, paginationState,
} from '@/store/components/pagination';

const initialState = () => ({
  ...baseState,
  ...sortState,
  ...paginationState,
});

export default {
  namespaced: true,
  state: initialState,
  actions: {
    ...baseActions,
    ...sortActions,
    ...paginationActions,
    async fetchItems({ commit }) {
      commit('setFetchProgress', true);
      commit('setFetchError', false);
      try {
        const { marketing_blocks: marketingBlocks } = await marketingApi.fetchBlocks();
        commit('setItems', marketingBlocks);

        if (marketingBlocks.length) {
          commit('setItemId', marketingBlocks[0].id);
          commit('setItem', marketingBlocks[0]);
        }
      } catch (err) {
        commit('setFetchError', true);
        commit('notifications/addNotifyErrors', ['Ошибка загрузки маркетинговых блоков'], { root: true });
        return Promise.reject(err);
      } finally {
        commit('setFetchProgress', false);
      }
    },

    async fetchItem({ state, commit }) {
      if (!state.itemId) return Promise.reject();
      commit('setFetchItemProgress', true);
      try {
        const response = await marketingApi.fetchBlockItem({ id: state.itemId });
        commit('setItem', response);
        return response;
      } catch (err) {
        commit('notifications/addNotifyErrors', ['Ошибка загрузки маркетингового блока'], { root: true });
        return Promise.reject(err);
      } finally {
        commit('setFetchItemProgress', false);
      }
    },

    async createItem({ commit, dispatch }, { data }) {
      commit('setCreateProgress', true);
      try {
        const response = await marketingApi.createBlockItem({ data });
        dispatch('fetchItems');
        commit('notifications/addNotifySuccess', ['Маркетинговый блок успешно создан'], { root: true });
        return response;
      } catch (err) {
        commit('notifications/addNotifyErrors', ['Ошибка создания маркетингового блока'], { root: true });
        return Promise.reject(err);
      } finally {
        commit('setCreateProgress', false);
      }
    },

    async updateItem({ commit, dispatch }, { id, data }) {
      commit('setUpdateProgress', true);
      try {
        const response = await marketingApi.updateBlockItem({ id, data });
        commit('setItem', response);
        dispatch('fetchItems');
        commit('notifications/addNotifySuccess', ['Маркетинговый блок успешно изменен'], { root: true });
        return response;
      } catch (err) {
        commit('notifications/addNotifyErrors', ['Ошибка изменения маркетингового блока'], { root: true });
        return Promise.reject(err);
      } finally {
        commit('setUpdateProgress', false);
      }
    },

    // async deleteItem({ commit, dispatch }, { id }) {
    //   commit('setDeleteProgress', true);
    //   try {
    //     const response = await workoutsApi.deleteItem({ id });
    //     dispatch('fetchItems');
    //     commit('notifications/addNotifySuccess', ['Специалист успешно удален'], { root: true });
    //     return response.data;
    //   } catch (err) {
    //     const { errors } = err.data;
    //     commit('notifications/addNotifyErrors', errors, { root: true });
    //     return Promise.reject(errors);
    //   } finally {
    //     commit('setDeleteProgress', false);
    //   }
    // },
  },
  mutations: {
    ...baseMutations,
    ...sortMutations,
    ...paginationMutations,
    clearState(state) {
      Object.entries(initialState()).forEach(([key, value]) => { state[key] = value; });
    },
  },
  getters: {
    ...baseGetters,
    ...sortGetters,
    ...paginationGetters,
  },
};
